import { ProcessingRequestDetails } from "./ProcessingRequest";
import { Warehouse } from "./Warehouse";
import { Product } from "./Product";

export enum AtestType {
  Domaci = "Domaći",
  Strani = "Strani",
}

export interface ProcessingOrderListItem {
  id: string;
  requestId: string;
  request?: ProcessingRequestDetails;
  requestNumber?: string;
  number?: string;
  date?: Date;

  processingCenterId?: string;
  processingCenter?: Warehouse;

  plantType?: string;
  sortId?: string;
  sort?: Product;
  seedCategory?: string;

  approvalNumber?: string;
  approvalDate?: Date;

  packingType?: string;
  packageCount?: number;
  totalAmountKg?: number;

  treatment?: string;
  atestType?: AtestType;
  atestOECD?: boolean;
  atestORANZ?: boolean;
  atestGMO?: boolean;
  atestRwaExport?: boolean;
  barcode?: string;
}

export interface ProcessingOrderDetails extends ProcessingOrderListItem {
  contactPerson?: string;
  batches?: ProcessingBatch[];
  hasDeclarations?: boolean;
}

export interface ProcessingOrderCreate {
  requestId: string;
  number?: string;
  date?: Date;

  processingCenterId: string;

  plantType?: string;
  sortId?: string;
  seedCategory?: string;

  approvalNumber?: string;
  approvalDate?: Date;

  packingType?: string;
  packageCount?: number;
  totalAmountKg?: number;

  treatment?: string;
  atestType?: AtestType;
  atestOECD?: boolean;
  atestORANZ?: boolean;
  atestGMO?: boolean;
  atestRwaExport?: boolean;
  barcode?: string;

  contactPerson?: string;

  // opcionalno: inicijalne partije
  batches?: {
    code: string;
    planAmountKg?: number;
    note?: string;
  }[];
}

export interface ProcessingOrderUpdate extends Partial<ProcessingOrderCreate> {
  id: string;
  hasDeclarations?: boolean;
}

export interface ProcessingBatch {
  id?: string;
  orderId?: string;
  code: string;
  planAmountKg?: number;
  note?: string;
}

export interface ProcessingBatchCreate {
  orderId: string;
  code: string;
  planAmountKg?: number;
  note?: string;
}

export interface ProcessingBatchUpdate extends Partial<ProcessingBatchCreate> {
  id: string;
}
